import React, { useMemo } from 'react';
import cx from 'classnames';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GroupIcon from '@mui/icons-material/Group';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ReceiptIcon from '@mui/icons-material/Receipt';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import styles from '@/common/containers/UserIntro/styles.less';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';

const Fifth = () => {
  const { t } = useTranslation();
  const copyrightSup = <CopyrightSup />;
  const list = useMemo(
    () => [
      {
        Icon: AccountBalanceIcon,
        title: t(
          'Legally responsible for managing and distributing the estate'
        ),
        text: t(
          'If you are named as the “Executor”, you are authorized to administer the estate of the deceased person. You are considered the deceased person’s personal representative, and will carry out their wishes as stated in the will.'
        ),
      },
      {
        Icon: GroupIcon,
        title: t('If there is a Co-Executor'),
        text: t(
          'The Executor and Co-Executor are each individually fully responsible for managing the estate.\nWhen more than one person is appointed to act as ‘co-executor/s’, decision-making between the executors will be governed by the will. If the will is silent on the issue, then unanimous consent is required. A co-executor should not act unilaterally, nor hide information or facts from the other executors.'
        ),
      },
      {
        Icon: AssignmentIcon,
        title: t('The Duty to Account '),
        text: t(
          'Executors must provide an accounting of all of the assets of the estate.'
        ),
      },
      {
        Icon: BusinessCenterIcon,
        title: t('Estate Assets '),
        text: t(
          'Executors have a duty to maximize the recovery, and value, of estate assets.'
        ),
      },
      {
        Icon: ReceiptIcon,
        title: t('Executor Liability'),
        text: t(
          'An executor may be personally liable for estate debts if the executor fails to make adequate provision for payment of all estate debts, particularly with respect to taxes.'
        ),
      },
      {
        Icon: VerifiedUserIcon,
        title: t('Secure Assets'),
        text: t(
          'An Executor is responsible for securing all estate assets to include: taking control of, protecting (if possible), and insuring assets; arranging for asset safekeeping; starting and/or getting valuations of assets.'
        ),
      },
      {
        Icon: ChromeReaderModeIcon,
        title: t('Keep good records'),
        text: t(
          'An Executor has an obligation to KEEP COMPLETE and ACCURATE RECORDS starting immediately following the death.'
        ),
      },
    ],
    [t]
  );

  return (
    <div className={cx(styles.screen, styles.fifth)}>
      <h4 className={styles.screenTitle}>{t('Executor Responsibilities')}</h4>
      <p className={styles.screenLabel}>
        <Trans
          i18nKey="Before proceeding, it is critically important that Executors understand their legal obligations resulting from being appointed to this role. PAEM After Care<copyrightSup/> has numerous features including Task Lists, Task and Asset Details Pages, and Notes that help Executors manage, track, and document the PAEM<copyrightSup/> process to help meet these legal obligations."
          components={{ copyrightSup }}
        />
      </p>
      <div className={styles.fifthList}>
        {list.map(({ Icon, title, text }) => (
          <div key={title} className={styles.fifthItem}>
            <div className={styles.fifthItemIcon}>
              <Icon />
            </div>
            <div className={styles.fifthItemTitle}>{title}</div>
            <div className={styles.fifthItemLabel}>{text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Fifth;
